import { useEffect, useState } from "react";
import React from "react";
import reactStringReplace from "react-string-replace";
import {
  Box,
  Button,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@mui/material";
import { submitAnswerGaps, useApi } from "../api/Api";
import QuestionFillGapsSolution from "./QuestionFillGapsSolution";
import { useTranslation } from "react-i18next";
import QuestionDescription from "./QuestionDescription";

const QuestionFillGaps = ({
  question,
  fetchQuizStats,
  fetchCurrentQuestion,
}) => {
  const { t } = useTranslation();
  const api = useApi();

  const [gaps, setGaps] = useState(Array(question["options"].length).fill(""));

  const [openAlert, setOpenAlert] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [correct, setCorrect] = useState();
  const [solution, setSolution] = useState();
  const [changeQuestion, setChangeQuestion] = useState(false);

  const handleClose = () => {
    setOpenAlert(false);
    setFeedback("");
    if (changeQuestion) fetchCurrentQuestion();
    fetchQuizStats();
  };

  useEffect(() => {
    if (!!feedback) setOpenAlert(true);
  }, [feedback]);

  const submitAnswer = () => {
    submitAnswerGaps(api, gaps)
      .then((response) => {
        let respData = response["data"];
        setCorrect(respData["correct"]);
        setFeedback(respData["feedback"]);
        setSolution(respData["solution"]);
        setChangeQuestion(respData["change_question"]);
      })
      .catch((error) => console.log(error));
  };

  const updateGapMap = (event, idx) => {
    let gapsCpy = JSON.parse(JSON.stringify(gaps));
    gapsCpy[idx] = event.target.value;
    setGaps(gapsCpy);
  };

  const optionMenuItems = question["options"].map((option) => (
    <MenuItem value={option}>{option}</MenuItem>
  ));

  const optionsTextArray = question.text
    .split("\n")
    .join("\\n")
    .split("\\n")
    .reduce((acc, cur) => {
      acc.push(cur);
      return acc;
    }, []);

  let gapMapIdx = 0;

  const optionsElements = optionsTextArray.map((text) => {
    return reactStringReplace(text, "${}", (match, i) => {
      const index = gapMapIdx++;
      return (
        <Select
          variant="standard"
          sx={{ minWidth: 100, textAlign: "center", px: 1 }}
          onChange={(event) => updateGapMap(event, index)}
        >
          {optionMenuItems}
        </Select>
      );
    });
  });

  return (
    <Grid container justifyContent="center" alignItems="center" spacing={2}>
      <Paper elevation={10} sx={{ m: 1, p: 1, maxWidth: 1000 }}>
        <CardContent>
          {/*<Typography variant="h6" sx={{mb: 1}}>{t("question_type")}: {t("fill_in_the_gaps")}</Typography>*/}
          {/*<Typography variant="h6" sx={{mb: 1}}>{t("question_no")} {question["questionid"]}</Typography>*/}
          {question["img"] ? (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ my: 2 }}
            >
              <img
                src={question["img"]}
                style={{ maxHeight: 350, maxWidth: "100%" }}
                alt={t("question")}
              />
            </Grid>
          ) : null}
          <QuestionDescription description={question["description"]} />
          <Box textAlign="justify">
            {optionsElements.map((e) => (
              <Box>{e}</Box>
            ))}
          </Box>
        </CardContent>
        <Box textAlign="center" xs={{ m: 2 }}>
          <Button variant="contained" onClick={() => submitAnswer()}>
            {t("submit_answer")}
          </Button>
        </Box>
      </Paper>
      <Dialog
        open={openAlert}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {correct ? t("correct_answer") : t("incorrect_answer")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {feedback}
            {solution === undefined ? (
              <></>
            ) : (
              <Box sx={{ mt: 2 }}>
                <Typography variant="h6">{t("solution")}</Typography>
                <QuestionFillGapsSolution question={solution} />
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t("close")}</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default QuestionFillGaps;
